// d3 imports
import { timeParse } from 'd3-time-format';

// Small multiples settings

/** Get a custom x-axis domain for each president's data by getting the year (last 2 digits of date) and setting the min as Jan. 20 and the max as April 30 of that year */
export function getCustomXDomain<T extends Record<string, unknown>>(
  data: T[]
): [Date, Date] | [string, string] {
  // Set d3 date parser to parse the date values in the data
  const dateParserFn = timeParse('%d/%m/%Y');

  const firstDateVal = data[0].date as string;
  const year = firstDateVal.slice(-4);
  return [dateParserFn(`20/01/${year}`), dateParserFn(`30/04/${year}`)];
}

export function yTickFormatter(tick: number) {
  const prefix =
    tick < 0 ? '–'
    : tick > 0 ? '+'
    : '';

  return `${prefix}${Math.abs(tick)}`;
}

/** Calculates the rolling average for data */
export function getRollingAverageData<T extends Record<string, unknown>>(
  data: T[],
  yValKey: string,
  windowSize: number
) {
  return data.map((dataPoint, index) => {
    let sum = 0;
    let count = 0;

    let j = Math.max(0, index - windowSize + 1);
    while (j <= index) {
      const value = data[j][yValKey];

      if (typeof value === 'number') {
        sum += value;
        count++;
      } else {
        console.warn(
          `Value at index ${j} for key ${yValKey} is not a number. Skipping.`
        );
      }
      j++; // Increment j here
    }

    const rollingAverage = count > 0 ? sum / count : null; // Use null when there are no valid values in the window

    return {
      ...dataPoint,
      [`${yValKey}`]: rollingAverage,
    };
  });
}
